import { Directive } from '@angular/core';
import { environment } from '@fb-tool-front/environments/environment';
import { combineLatest } from 'rxjs';
import { debounceTime, withLatestFrom } from 'rxjs/operators';
import amplitude from 'amplitude-js';
import { AuthService } from '@fb-tool-front/core/services/auth.service';

@Directive({
  selector: '[appAmplitude]'
})
export class AmplitudeDirective {
  constructor(private authService: AuthService) {
    amplitude.getInstance().init(environment.amplitudeApiKey);
    combineLatest([this.authService.user$, this.authService.client$])
      .pipe(debounceTime(100), withLatestFrom(this.authService.userData$))
      .subscribe(([[user, client], userData]) => {
        if (!user) {
          amplitude.getInstance().setUserId(null);
          amplitude.getInstance().clearUserProperties();
          amplitude.getInstance().setUserProperties({
            utm: this.authService.getUtm()
          });
          return;
        }
        amplitude.getInstance().setUserId(user?.username);
        amplitude.getInstance().setUserProperties({
          client: client?.id,
          email: user?.email,
          impersonated: user?.impersonated,
          subscriptions: client?.subscriptions?.map(el => el.id),
          isAitarget: user?.isAitarget || false,
          utm: this.authService.getUtm() || userData?.utm
        });
      });
  }
}
